import { AgGridReact } from '@ag-grid-community/react';
import { Button, Paper, Stack, Typography } from '@mui/material';
import "@ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "@ag-grid-community/styles/ag-theme-material.css"; // Optional theme CSS
import "@ag-grid-community/styles/ag-theme-alpine.css";
import { ColDef } from '@ag-grid-community/core';
import { useEffect, useMemo, useRef } from 'react';
import { useNavigate } from "react-router-dom";

type Props = {
  title: string;
  subtitle?: string;
  rowData: any[];
  columnDefs: ColDef[];
  selectedSessionFilter?: string[];
  ddAvailable?: boolean;
  eegData?: any;
  imagingData?: any;
}

const DataTable = ({ title, subtitle, rowData, columnDefs, selectedSessionFilter, ddAvailable, imagingData, eegData }: Props) => {
    const gridRef = useRef<AgGridReact>(null);
    const navigate = useNavigate()
    const sessionFilteredRows = useMemo(() => {
        if(!selectedSessionFilter){
            return rowData;
        }
        const set = new Set(selectedSessionFilter);
        const rows = rowData.filter(row => set.has(row.label));

        return rows.length > 0 ? rows : [{ label: "No Sessions Selected" }];
    }, [rowData, selectedSessionFilter])

    const eegLabels = useMemo(() => {
        return Object.keys(eegData || {}).reduce((acc: any, key) => {
            const title = eegData?.[key]?.title;
            if (title) {
                acc[title] = key;
            }
            return acc;
        }, {});
    }, [eegData]);

    const onClick = (() => {
        if (Object.keys(eegLabels).includes(title)){
            navigate("/data-wrangler",{ state: { dictSearch: eegLabels?.[title] } })
        }
        else{
            navigate("/data-wrangler",{ state: { dictSearch: title } })
        }
    })

    useEffect(() => {
        window.addEventListener('resize', () => gridRef?.current?.api?.sizeColumnsToFit());
        // cleanup
        return () => {
            window.removeEventListener('resize', () => gridRef?.current?.api?.sizeColumnsToFit());
        };
    }, []);


    return (
        <Paper sx={{
            padding: "20px",
            marginBottom: "16px",
            borderRadius: 1,
        }}>
            <Stack gap={3}>
                <Typography variant={"h5"} fontWeight={"bold"}>{title}</Typography>
                {subtitle && <Typography>{subtitle}</Typography>}
                <div className={"ag-theme-alpine"} style={{ width: '100%', display: "block", }}>
                    <AgGridReact
                        ref={gridRef}
                        key={title}
                        rowData={sessionFilteredRows}
                        columnDefs={columnDefs}
                        domLayout={'autoHeight'}
                        autoSizeStrategy={{ type: 'fitGridWidth' }}
                        suppressDragLeaveHidesColumns = {true} // to prevent dragging the column outside the box
                    />
                </div>
            </Stack>

            {ddAvailable && !Object.keys(imagingData).includes(title) &&
            <Button
                sx={{ margin: 2 }}
                variant="outlined"
                onClick={onClick}
                onMouseDown={(e) => e.preventDefault()}
            >
                View Data Dictionary
            </Button>}

        </Paper>
    )
}

export default DataTable;